<template>
  <v-text-field
    outlined
    dense
    :label="fieldKey"
    :value="value"
    @input="handleOnInput"
  ></v-text-field>
</template>

<script>
import { BaseFieldMixin } from './BaseFieldMixin'
import Enums from '@/helpers/Enums'
export default {
  name: 'PlainTextField',
  mixins: [BaseFieldMixin],
  props: {
    value: null,
    fieldType: {
      //overriding the setting from mixin
      type: String,
      required: false,
      default: () => {
        return Enums.FieldEditorType.plainText
      }
    }
  },
  data: function() {
    return {
      localValue: null
    }
  },
  created: function() {},
  methods: {
    handleOnInput: function(param) {
      this.$emit('input', param)
    }
  }
}
</script>

<style scoped></style>
